import type { JSX } from "react";

import { Route, Routes } from "react-router-dom";
import Add from "./Add";
import TtsProjectsPage from "./TtsProjectsPage";
import TtsProjectView from "./TtsProjectView";

function TtsRoutes(): JSX.Element {
    return (
        <Routes>
            <Route index element={<TtsProjectsPage />} />
            <Route path="add" element={<Add />} />
            <Route path=":id" element={<TtsProjectView />} />
        </Routes>
    );
}

export default TtsRoutes;
